@if (state === 'loading') {
  <shared-auth-progress></shared-auth-progress>
} @else {
<div class="main">
  @if (state == 'selectAccount') {
    <div class="d-flex justify-content-end p-4">
      @if (currentUser$ | async) {
        <img [src]="(currentUser$ | async)?.picture"
          class="border rounded-circle thumbnail" role="button" data-bs-toggle="modal"
          data-bs-target="#staticBackdrop" width="50px">
      }
    </div>
  }

  <div class="login-layout">
    <div class="body p-4 p-sm-5 rounded-3 shadow-sm">
      <header class="d-flex flex-column align-items-center">
        <img class="logo mb-4" id="prompt-logo-center" src="https://kartorium.app/assets/logo.png"
          alt="Kartorium">

          <h1>{{ state === 'selectAccount' ? 'Choose organization' : 'Welcome' }}</h1>


          @if (state == 'authRecovery') {
            <p class="fs-6 text-center">
              {{ migrationError || signInError || 'Sign-in is taking longer than expected.' }}
            </p>
            <button type="button" class="btn btn-primary" (click)="retryAuthLogin()">
              Continue sign-in
            </button>
          }

          @if (state == 'accountRecovery') {
            <p class="fs-6 text-center" role="alert">{{ signInError }}</p>
            <button type="button" class="btn btn-primary" (click)="retryAccountLoad()">
              Retry loading accounts
            </button>
          }

          @if (state == 'migrationRecovery') {
            <p class="fs-6 text-center" role="alert">{{ migrationError }}</p>
            @if (migrationRecovery == 'retryable') {
              <button type="button" class="btn btn-primary mb-2" (click)="retryMigrationCompletion()">
                Retry account connection
              </button>
              <button type="button" class="btn btn-outline-primary mb-2" (click)="resumeMigrationWithPassword()">
                Sign in again with Kartorium password
              </button>
            }
            <button type="button" class="btn btn-outline-primary" (click)="continueWithPasswordAccount()">
              Continue with password account
            </button>
            <button type="button" class="btn btn-link mt-2" (click)="signOut()">
              Sign out
            </button>
          }

          @if (state == 'accountNotProvisioned') {
            <p class="fs-6 text-center mb-2">
              This account has not been provisioned for Kartorium.
            </p>
            <p class="text-muted text-center mb-3">
              Contact <a href="mailto:support@kartorium.com">support&#64;kartorium.com</a>.
            </p>
            <button type="button" class="btn btn-outline-primary" (click)="signOutUnprovisionedAccount()">
              Sign out and use another account
            </button>
          }

          @if (state == 'migrateAccount') {
            <p class="fs-6 text-center">Connect your existing Kartorium account</p>
            <p class="text-muted text-center">Connect your existing account with its Kartorium password to use its projects, assets, and permissions. You can sign out if you do not want to connect now.</p>
            @if (migrationError) {
              <p class="text-danger" role="alert">{{ migrationError }}</p>
            }
            <button type="button" class="btn btn-primary" [disabled]="migrationInProgress" (click)="migrateExistingAccount()">
              {{ migrationInProgress ? 'Connecting accounts...' : 'Continue with Kartorium password' }}
            </button>
            <button type="button" class="btn btn-link mt-2" [disabled]="migrationInProgress" (click)="signOut()">
              Sign out
            </button>
          }
        </header>

        <!-- Organization Body -->
        @if (state == 'selectAccount') {
          <div class="d-flex flex-column gap-2">
            @if (signInError) {
              <p class="text-danger" role="alert">{{ signInError }}</p>
              <button type="button" class="btn btn-primary" (click)="retryAuthLogin()">Return to sign in</button>
            }
            @if (organizations.length > 3) {
              <input class="form-control" type="search" [(ngModel)]="search"
                placeholder="Search">
            }
            <ul class="list-group">
              @for (org of organizations | searchSortByKeys: ['name', 'display_name'] : search; track org) {
                <li
                  class="list-group-item list-group-item-action d-flex align-items-center d-grid gap-2"
                  type="button" (click)="accountLogin(org)">
                  <img class="logo-sm" [src]="org?.branding?.logo_url ?? defaultLogo" alt="Logo">
                  <span class="fw-bold">{{org.display_name}}</span>
                </li>
              }
            </ul>
            @if (hasPersonalAccount) {
              <li class="list-group list-group-item text-white scheme-bg-dark"
                type="button" (click)="accountLogin()">
                <i class="fas fa-user me-1"></i>
                My Account
              </li>
            }
            <small class="text-muted">
              Having trouble? Contact <a href="mailto:support@kartorium.com">support@kartorium.com</a>
            </small>
          </div>
        }
      </div>
    </div>
  </div>

}
